const setConsentOnUserAcceptCallback = (consentTigger: (consent: boolean) => void): void => {
  window.addEventListener(
    'CookiebotOnAccept',
    () => {
      const cookiebotInstance = (window as any).Cookiebot;
      consentTigger(cookiebotInstance.consent.statistics);
    },
    false,
  );
};

const setConsentOnUserDeclineCallback = (consentTigger: (consent: boolean) => void): void => {
  window.addEventListener(
    'CookiebotOnDecline',
    () => {
      const cookiebotInstance = (window as any).Cookiebot;
      consentTigger(cookiebotInstance.consent.statistics);
    },
    false,
  );
};

export { setConsentOnUserAcceptCallback, setConsentOnUserDeclineCallback };
